import React from "react";
import Modal from "../modal/ModalComponent";

const UpdatePassword = () => {
  return (
    <Modal
      isClose={false}
      userId={""}
      otpTimer={0}
      otpType={""}
      transType="redirectChangePassword"
      type="UPDATE"
      header="Update Password"
    ></Modal>
  );
};

export default UpdatePassword;
